module.exports = __webpack_public_path__ + "static/media/de_wco.dd2ed215.png";